// @flow

import { createBrowserHistory } from 'history';

const params =
  process.env.NODE_ENV && process.env.NODE_ENV === 'test'
    ? undefined
    : { basename: '/_mvc/share' };

const history = createBrowserHistory(params);

export default history;
